import { regionService } from "../services";

// state
const state = {
  items: [],
  item: {},
  loading: true
};

// ACTIONS
const actions = {

  // create new region
  CREATE_REGION({ commit }, options) {
    commit("requestSent");
    options = options || {}
    return new Promise((resolve, reject) => {
      regionService.createRegion(options).then(
        region => {
          commit("fetchItemSuccess", region);
          resolve(region);
        },
        error => {
          commit("requestFail", region);
          reject(error);
        }
      );
    });
  },

  // remove region
  DELETE_REGION({ commit }, options) {
    return new Promise((resolve, reject) => {
      regionService.removeRegion(options).then(
        () => {
          commit("deleteItem", options.id);
          resolve(true);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  // add item to items
  ADD_ITEM({ commit }, item) {
    if (item) commit("addItem", item);
  },
};

// MUTATIONS
const mutations = {
  // http request fails
  requestFail(state) {
    state.loading = false;

  },
  // http request sent
  requestSent(state) {
    state.loading = true;
  },

  // model
  fetchItemSuccess(state, item) {
    state.loading = false;
    state.item = item;
  },

  // add question to questions
  addItem(state, item) {
    state.items.push(item);
  },
  // remove item from items
  deleteItem(state, id) {
    state.items = state.items.filter(item => item.id == id);
  },
};

// GETTERS
const getters = {
  isLoading: state => state.loading
};

// EXPORT
export const region = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
